import { classnames } from '@aibees/shared/utils';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ColumnChartProps as Props } from './types';

export const ColumnChart = memo(({ className, options }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('ColumnChart', className)}
      sx={SX.root}
    >
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Styled.Wrapper>
  );
});

ColumnChart.displayName = 'ColumnChart';
